
import FabMenuItem from "@/components/FabMenuItem.vue";
import { defineComponent } from "vue";
import { useGroupedRecords, useMap } from "@/services";
import { DRAW_MODE, MapDrawSelection } from "@/types";

export default defineComponent({
  name: "LayerEditTools",
  components: { FabMenuItem },
  data: () => ({
    mapStore: useMap(),
    groupsRecord: useGroupedRecords(),
    isSaving: false,
    // groupId: 0,
    showGroupSelector: false,
  }),
  computed: {
    isEditingLayer(): boolean {
      return this.mapStore.isEditingLayer;
    },
    editMode(): MapDrawSelection {
      return this.mapStore.editingMode;
    },
    isGroupTaken(): boolean {
      return this.groupsRecord.groupsSet.has(this.groupsRecord.selectedGroup);
    },
    groupId(): string {
      return this.groupsRecord.selectedGroup;
    },
    layerTools(): any[] {
      return [
        {
          mode: "draw_polygon",
          icon: "s-polygon",
          title: "Draw polygon",
          src: require("../../assets/icons/s-polygon.svg"),
          variant: "light",
          action: () => this.setMode("draw_polygon"),
        },
        {
          mode: "simple_select",
          iconType: "bi",
          icon: "cursor",
          title: "Select",
          variant: "light",
          action: () => this.setMode("simple_select"),
        },

        {
          mode: "remove",
          icon: "x",
          title: "Clear drawings",
          iconType: "bi",
          variant: "outline-danger",
          action: () => this.clear(),
        },
      ];
    },
  },
  methods: {
    finish() {
      if (this.mapStore.editLayer && this.mapStore.editLayer.polygon) {
        if (!this.groupId || this.isGroupTaken) {
          this.showGroupSelectorModal();
        } else {
          this.save();
        }
      } else {
        this.mapStore.setEditLayer(null, { isFocusMode: true });
      }
    },
    showGroupSelectorModal() {
      if (this.mapStore.editLayer?.polygon) {
        this.showGroupSelector = true;
      }
    },
    setMode(mode: DRAW_MODE) {
      if (this.mapStore.editingMode.mode === mode) {
        return;
      }

      if (this.mapStore.editLayer) {
        this.mapStore.mapDraw.deleteAll();
        this.mapStore.editLayer.polygon = null;
      }

      this.mapStore.setEditingMode({ mode });
    },
    clear() {
      this.mapStore.clearEditLayerPolygon();
    },
    cancel() {
      this.$root.$bvModal.hide("group-selector");
    },
    async save(): Promise<void> {
      if (!this.groupId || !this.mapStore.editLayer?.polygon) {
        return;
      }

      this.isSaving = true;

      await this.mapStore.addBoundary(parseInt(this.groupId));
      this.$root.$bvModal.hide("group-selector");
      this.mapStore.setEditLayer(null, { isFocusMode: true });

      this.isSaving = false;
    },
  },
});
